import { PAYMENT_TYPES } from '@vend/business-components/dist/constants/payment-types'
import { subtract } from 'vend-number'
import { useEffect, useState } from 'react'

import { useWebRegisterStatusManager } from '../../../../ng-compat/hooks'
import { useAppSelector } from '../../../../state/hooks'
import {
  selectCustomerBalances,
  selectTotalPartialPayments,
} from '../../../../state/slices/currentSale/currentSaleSlice'

import { EVENTS } from '../../../../constants/status'

/**
 * Hook to get the available store credit for the current sale
 */
export const useAvailableStoreCredit = () => {
  const webRegisterStatusManager = useWebRegisterStatusManager()

  const customerBalances = useAppSelector(selectCustomerBalances)
  const [isOnline, setIsOnline] = useState<boolean>(
    webRegisterStatusManager.isOnline()
  )
  const [availableStoreCredit, setAvailableStoreCredit] = useState(0)

  const totalPartialPayments = useAppSelector(
    selectTotalPartialPayments(PAYMENT_TYPES.STORE_CREDIT)
  )
  useEffect(() => {
    const transitionOnline = () => setIsOnline(true)
    const transitionOffline = () => setIsOnline(false)
    webRegisterStatusManager.on(EVENTS.transitionOnline, transitionOnline)
    webRegisterStatusManager.on(EVENTS.transitionOffline, transitionOffline)

    return () => {
      webRegisterStatusManager.off(EVENTS.transitionOnline, transitionOnline)
      webRegisterStatusManager.off(EVENTS.transitionOffline, transitionOffline)
    }
  }, [webRegisterStatusManager])

  useEffect(() => {
    if (!isOnline || !customerBalances) {
      setAvailableStoreCredit(0)
      return
    }
    const storeCredit = customerBalances.storeCredit
    const customerStoreCreditBalance = (storeCredit && storeCredit.balance) || 0

    const balance = subtract(customerStoreCreditBalance, totalPartialPayments)

    setAvailableStoreCredit(balance)
  }, [customerBalances, isOnline, totalPartialPayments])

  return availableStoreCredit
}
